import api, { checkTokenErrorResponse } from '..';


export async function getBankAccountsTransfers() {
    return api.get("transferencias_bancarias/")
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};

export async function postBankAccountTransfer(conta_origem, conta_destino, valor, data, descricao) {
    const dataSend = {
        conta_origem,
        conta_destino,
        data,
        valor: Number(valor),
        descricao
    }

    return api.post(`transferencias_bancarias/`, dataSend)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};


export async function getBankAccountTransfer(id) {
    return api.get(`transferencias_bancarias/${id}/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};

export async function deleteBankAccountTransfer(id) {
    return api.delete(`transferencias_bancarias/${id}/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};


export async function patchBankAccountTransfer(id, conta_origem, conta_destino, valor, data, descricao) {
    const dataSend = {
        conta_origem,
        conta_destino,
        data,
        valor: Number(valor),
        descricao
    }

    return api.patch(`transferencias_bancarias/${id}/`, dataSend)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};


const bankAccountTransferServices = {
    getBankAccountsTransfers,
    getBankAccountTransfer,
    postBankAccountTransfer,
    deleteBankAccountTransfer,
    patchBankAccountTransfer,
}
export default bankAccountTransferServices;